import { useMutation, useQueryClient } from 'react-query';
import { createCompany, CreateCompanyParams } from '~/api/admin';

export function useCreateCompany() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: CreateCompanyParams) => createCompany(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['companies']);
    },
  });
}
